import type { LabelHTMLAttributes, ReactNode } from 'react';

interface FormLabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
    htmlFor: string;
    required?: boolean;
    children: ReactNode;
}

export const FormLabel = ({
    htmlFor,
    required = false,
    children,
    className = 'block text-backgroundGreen font-interstate mb-2 text-sm sm:text-base',
    ...rest
}: FormLabelProps) => (
    <label htmlFor={htmlFor} className={className} {...rest}>
        {children}
        {required && <span className="required"> *</span>}
    </label>
);
